<template>
  <div class="media">
    <div class="media-body item-content">
      <h5>
        <!-- <img :src="item.image" class="img-checkout" /> -->
        {{ _T_DB(item, 'name') }}
        <span class="font-primary">x ({{ item.quantity }})</span>
      </h5>
      <!-- <h5 class="font-primary">x{{ item.quantity }}</h5> -->
      <ul v-if="item.modifiers">
        <li v-for="(modifier, key) in item.modifiers" :key="'mod' + key">
          <span> </span>
          <s class="unavailable" v-if="!availableByLocation(modifier)">
          {{ _T_DB(modifier, 'name') }}
          </s>
          <template v-else>
            {{ _T_DB(modifier, 'name') }}
          </template>
        </li>
      </ul>
    </div>
    <div class="text-right pt2">
      <!-- <h5 class="font-primary">x{{ item.quantity }}</h5> -->
      <h5>{{ currency }} {{ Num.price(item.collectivePrice) }}</h5>
      <!--Num.price(item.collectivePrice, item.original_value)-->
      <!-- <h5>{{ Num.price(item.collectivePrice) }}</h5> -->
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Item',
  props: { item: Object },
  components: {},
  computed: {
    ...mapGetters(['_T_DB', '_T', 'availableByLocation']),
  },
}
</script>
<style scoped>
.img-checkout {
  width: 10%;
  margin-right: 0.5rem;
}
.summary-card {
  padding: 0.5rem !important;
}
.unavailable {
  color: var(--color-primary) !important;
}
</style>
